import t from "../../../../../i18n";

export function hasThreshold(q: {
  minMetrology: number | null;
  maxMetrology: number | null;
  maxStdMetrology: number | null;
}) {
  const { minMetrology, maxMetrology, maxStdMetrology } = q;
  if (minMetrology !== null || maxMetrology !== null || maxStdMetrology !== null) {
    return t("commons.quantities.threshold.atleast.one.label");
  }
  return t("commons.quantities.threshold.none.label");
}
